export const applyDomainSpecificStyles = () => {
  const currentHost = window.location.host;
  const targetDomain = window.config?.domain;

  if (currentHost.startsWith("localhost") || currentHost === targetDomain) {
    if (targetDomain === "cha.izzimember.com") {
      document.body.classList.add("cha-domain");
    }
  }
};
